type IObj = {
  genus: string;
};

export const refactorData = (obj: IObj) => {
  return {
    genus: obj.genus
  };
};
